import { authHeader, handleResponse } from '../helpers';
export const FeedbackRptService = {
    fetchFeedbackData,fetchExtraBenefitData,GetDealerPaymentTransfer,GetDealerAvStockReport,getAllExtraBenfitRedeemPoint
};

function fetchFeedbackData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/GetFeedbackReport`, requestOptions)
        .then(handleResponse);
}

function getAllExtraBenfitRedeemPoint(data){
    const requestOptions ={
        method: 'Post',
        headers: authHeader(),
        body : JSON.stringify(data)
    };
    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/GetExtraBenefitRedeemReport`,requestOptions)
    .then(handleResponse);
}

function fetchExtraBenefitData(data) {
    
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/GetExtraBenefitReport`, requestOptions)
        .then(handleResponse);
}


function GetDealerPaymentTransfer(data) {
    
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/GetDealerPaymentTransfer`, requestOptions)
        .then(handleResponse);
}

function GetDealerAvStockReport(data) {
    
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}FeedbackRpt/DealerAvStockReport`, requestOptions)
        .then(handleResponse);
}

